import { useEffect, useState } from "react";
import { Nav, NavLink } from "./styles";
import api from "../../services/api";

export function NavBar() {

  



  return (
    <div>
   
        <Nav>
          <NavLink>Maria Antonia Antonina - Métodos Numéricos</NavLink>
        </Nav>;
    </div>
  );
}
